// Título e Descrição no Google para as páginas fixas do site.
// Editáveis em Admin → Textos de Páginas → "Google (SEO)" (doc page-texts
// `seo-pages`, campo settings[<key>] = { title, description }).
// A Academia usa os campos do formulário da Academia (doc `academia-form`).
// Manter sincronizado com backend/seo_routes.py (SEO_PAGE_DEFAULTS).

export const SEO_PAGES_DOC_ID = "seo-pages";

export const SEO_PAGES = [
  {
    key: "home", label: "Home", path: "/",
    title: "INXPEK | Inspeções, Certificações e Avaliação da Conformidade",
    description: "Inspeção de gás, combustíveis, equipamentos de diversão, equipamentos de trabalho, certificação energética e outras em Portugal.",
  },
  {
    key: "solucoes", label: "Soluções", path: "/solucoes",
    title: "Soluções — Edificação e Industrial · INXPEK",
    description: "Soluções INXPEK para Edificação (habitação, condomínios, empresas, municípios) e Industrial (fábricas, energia, oil & gas). Um único parceiro acreditado.",
  },
  {
    key: "servicos", label: "Serviços", path: "/servicos",
    title: "Serviços — Todos os tipos de inspeções · INXPEK",
    description: "Todos os serviços de inspeção INXPEK: gás, elétrica, elevadores, certificação energética, equipamentos sob pressão, termografia por drone, auditorias e ambiente.",
  },
  {
    key: "sobre-grupo", label: "Sobre nós · O Grupo", path: "/sobre/grupo",
    title: "O Grupo — Gasmed · Hotinspe · INXPEK",
    description: "INXPEK resulta da união entre Gasmed e Hotinspe. +35 anos de experiência, +300.000 consumidores em segurança. Acreditações IPAC, DGEG e IPQ.",
  },
  {
    key: "sobre-certificacoes", label: "Sobre nós · Certificações", path: "/sobre/certificacoes",
    title: "Certificações e acreditações · INXPEK",
    description: "Acreditações IPAC, autorizações DGEG e IPQ e norma ISO/IEC 17020 que garantem o rigor e a imparcialidade das inspeções INXPEK.",
  },
  {
    key: "sobre-oportunidades", label: "Sobre nós · Trabalhe connosco", path: "/sobre/oportunidades",
    title: "Trabalhe connosco — Oportunidades · INXPEK",
    description: "Junte-se à equipa INXPEK. Consulte as oportunidades de emprego em inspeção, engenharia e certificação e candidate-se online.",
  },
  {
    key: "sobre-noticias", label: "Sobre nós · Notícias", path: "/sobre/noticias",
    title: "Notícias · Sobre nós · INXPEK",
    description: "Notícias, atualizações e comunicados da INXPEK sobre inspeções, certificações e serviços técnicos em Portugal.",
  },
  {
    key: "sobre-blog", label: "Sobre nós · Blog", path: "/sobre/blog",
    title: "Blog · INXPEK",
    description: "Artigos e conselhos da INXPEK sobre inspeções, segurança e conformidade legal em Portugal.",
  },
  {
    key: "academia", label: "Academia", path: "/academia", source: "academia-form",
    title: "Academia — Formações técnicas · INXPEK",
    description: "INXPEK Academia: formações planificadas em inspeção, segurança e eficiência energética. Consulte os programas e faça a sua pré-inscrição.",
  },
  {
    key: "contactos", label: "Contactos", path: "/contactos",
    title: "Contactos — Fale connosco em 24h · INXPEK",
    description: "Contacte a INXPEK. Seg-Sex 09h00–18h00. Assistente virtual 24/7. Cobertura nacional.",
  },
  {
    key: "noticias", label: "Notícias (página geral)", path: "/noticias",
    title: "Notícias · INXPEK",
    description: "Notícias, atualizações e comunicados da INXPEK sobre inspeções, certificações e serviços técnicos em Portugal.",
  },
  {
    key: "politica-privacidade", label: "Política de Privacidade", path: "/politica-privacidade",
    title: "Política de Privacidade · INXPEK",
    description: "Como a INXPEK recolhe, utiliza e protege os seus dados pessoais, em conformidade com o RGPD.",
  },
  {
    key: "termos-condicoes", label: "Termos e Condições", path: "/termos-condicoes",
    title: "Termos e Condições · INXPEK",
    description: "Termos e condições de utilização do site e dos serviços INXPEK.",
  },
];

export const SEO_PAGES_BY_KEY = Object.fromEntries(SEO_PAGES.map((p) => [p.key, p]));

export const SEO_TITLE_MAX = 60;
export const SEO_DESCRIPTION_MAX = 160;

/** Texto simples cortado (para descrições automáticas). */
export function clipText(text, n = SEO_DESCRIPTION_MAX) {
  const t = String(text || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  if (t.length <= n) return t;
  const cut = t.slice(0, n - 1).replace(/\s+\S*$/, "").replace(/[,;:.\-–— ]+$/, "");
  return `${cut}…`;
}
